// 动态加载共有弹窗
const popup = (id, params) => {
  return new Promise((resolve) => {
    let fn = () =>
      import(
        /* webpackChunkName: "buyer-popup", webpackPrefetch: true */
        '@components/button/buyer-popup.js'
      )
    fn().then((res) => {
      const el = res.default.use(id, params)
      resolve(el)
    })
  })
}
export default {
  install: (Vue) => {
    Object.defineProperty(Vue.prototype, '$eventHub', {
      value: new Vue()
    })
    /* eslint-enable */
    Object.defineProperty(Vue.prototype, '$popup', {
      // import sellerPopup from '@components/button/buyer-popup.js'
      value: {
        use: async (id, params) => {
          const el = await popup(id, params)
          return el
        }
      }
    })
  }
}
